/**
 * Shared API client instance
 * Extracted to its own file to avoid circular dependency issues
 */

import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api/v1';
const AI_CRM_BASE = `${API_BASE_URL}/ai-crm`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: AI_CRM_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle response errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('AI CRM API: 401 Unauthorized - check if token exists:', !!localStorage.getItem('authToken'));
    }
    return Promise.reject(error);
  }
);

export { apiClient, AI_CRM_BASE, API_BASE_URL };
